// extracted by mini-css-extract-plugin
export default {"tableContainer":"UserTable_tableContainer__TBYfv","tableButtons":"UserTable_tableButtons__XEZQ8"};